import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Box, maxHeight } from "@mui/system";

import IconButton from "@mui/material/IconButton";
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { ColorModeContext } from "../app/App";
import React from "react";
import { Link, Tooltip } from "@mui/material";
import BLAK_LOGO, { BLAK_LOGO_LIGHT } from "../graphics/BLAK_LOGO";
import Icon from "../graphics/BLAK_LOGO_ENHANCED";

export default function AppTopBar(props) {
  const colorMode = React.useContext(ColorModeContext);
  return (
    <Box>
      <AppBar
        elevation={0}
        position="fixed"
        sx={{
          backgroundColor:
            props.theme.palette.mode === "dark" ? "#272727" : "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          sx={{
            paddingTop: 0.5,
            paddingBottom: 0.5,
            borderBottom: "3px solid #009fe3",
          }}
        >
          {props.theme.palette.mode === "dark" ? (
            <Link href="/" sx={{ display: "flex", flexDirection: "column" }}>
              <Icon />
            </Link>
          ) : (
            <Link href="/" sx={{ display: "flex", flexDirection: "column" }}>
              <BLAK_LOGO />
            </Link>
          )}
          <Typography
            variant="h5"
            noWrap
            component="div"
            sx={{
              marginLeft: 5.5,
              color: props.theme.palette.mode === "dark" ? "#fff" : "#70706f",
            }}
          >
            Herstellungsbereitschaft
          </Typography>

          <Tooltip
            title={
              props.theme.palette.mode === "dark" ? "Licht an!" : "Licht aus!"
            }
          >
            <IconButton
              sx={{
                ml: "auto",
                color: props.theme.palette.mode === "dark" ? "#fff" : "#70706f",
              }}
              onClick={colorMode.toggleColorMode}
            >
              {props.theme.palette.mode === "dark" ? (
                <Brightness7Icon />
              ) : (
                <Brightness4Icon />
              )}
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
